import { Link } from "react-router-dom";
import { Reveal } from "../components/Reveal";
import SectionNav from "../components/SectionNav";
import { PageHero, SectionHead, CtaBand } from "../components/ui";
import GridNetwork from "../components/GridNetwork";
import { MARKETS, PROJECTS, FID_NOTE } from "../data/site";

const PROJECT_SECTIONS = [
    { id: "network", label: "Network" },
    { id: "portfolio", label: "Portfolio" },
];

export default function Projects() {
    return (
        <>
            <PageHero
                eyebrow="Projects"
                lines={["Developing infrastructure-", "scale energy storage."]}
                trail={[{ label: "Home", path: "/" }, { label: "Projects" }]}
            />
            <SectionNav items={PROJECT_SECTIONS} navKey="projects" />
            <section id="network" className="bg-paper">
                <div className="container-x py-16 sm:py-20">
                    <Reveal>
                        <GridNetwork />
                    </Reveal>
                </div>
            </section>
            <section id="portfolio" className="border-t border-line bg-white">
                <div className="container-x py-20 sm:py-24 lg:py-28">
                    <SectionHead
                        eyebrow="Portfolio"
                        title="Two markets. Four developments. One standard of discipline."
                    />
                    <div className="mt-16 space-y-16 lg:space-y-20">
                        {MARKETS.map((m, i) => (
                            <Reveal key={m.country} delay={0.05}>
                                <div className="grid gap-8 lg:grid-cols-12">
                                    <div className="lg:col-span-4">
                                        <div className="sticky top-36">
                                            <p className="eyebrow mb-4">Market 0{i + 1}</p>
                                            <h3 className="font-display text-4xl font-bold tracking-[-0.02em] text-ink sm:text-5xl">
                                                {m.country}
                                            </h3>
                                            <div className="mt-8 hidden aspect-[4/3] overflow-hidden lg:block">
                                                <img
                                                    src={m.image}
                                                    alt={`Energy infrastructure in ${m.country}`}
                                                    loading="lazy"
                                                    className="img-grade h-full w-full object-cover"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="lg:col-span-8">
                                        <ul className="border-t border-line">
                                            {m.projects.map((p) => (
                                                <li key={p.id} className="border-b border-line">
                                                    <Link
                                                        to={`/projects/${p.slug}`}
                                                        className="group grid gap-4 py-8 transition-colors hover:bg-mist sm:grid-cols-12 sm:items-baseline"
                                                        data-testid={`project-card-${p.id}`}
                                                    >
                                                        <div className="sm:col-span-5">
                                                            <p className="font-display text-2xl font-bold text-ink transition-colors group-hover:text-blue">
                                                                {p.name}
                                                            </p>
                                                            <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.18em] text-ink-3">
                                                                {p.tech}
                                                                {p.pci ? ` · ${p.pci}` : ""} · {p.location}
                                                            </p>
                                                        </div>
                                                        <div className="sm:col-span-5">
                                                            <p className="font-mono text-[12px] leading-relaxed text-ink-2">
                                                                {p.stats.map((s) => `${s.prefix ? s.prefix + " " : ""}${s.value} ${s.unit}`).join(" · ")}
                                                                <br />
                                                                <span className="text-ink-3">{p.duration} duration</span>
                                                            </p>
                                                        </div>
                                                        <div className="flex items-baseline justify-end sm:col-span-2">
                                                            <span className="link-underline !normal-case">View project →</span>
                                                        </div>
                                                    </Link>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </Reveal>
                        ))}
                    </div>
                    <Reveal delay={0.1}>
                        <p className="mt-14 border-l-2 border-blue bg-mist px-6 py-4 font-mono text-[11px] uppercase tracking-[0.16em] text-ink-2" data-testid="fid-note">
                            {FID_NOTE}
                        </p>
                    </Reveal>
                </div>
            </section>
            <CtaBand />
        </>
    );
}
